import PDFPageViewer from './PDFPageViewer';
import SupportEmail from "../components/SupportEmail";

const Security = () => {
  const pdfUrl = "https://omegavoid.com/documents/Omega_Void_Whitepaper.pdf";

  return (
    <>
      <div className="security-container">
        <h1>Security, Privacy & Anti-Fraud Statement</h1>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="lock-icon"></i>
          </div>
          <h2>Limited Metadata Collection</h2>
          <p>
            Omega Void™ collects limited technical metadata strictly for platform security and abuse
            prevention. This includes IP address and device identifiers used to detect bot activity, prevent
            mass account creation, enforce rate limits, and protect infrastructure from automated attacks.
            This data is never used to identify users personally, is not sold or shared with third parties,
            and is not connected to names, email addresses, or real-world identity. Omega Void™ does
            not collect personal information.
          </p>
        </div>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="key-icon"></i>
          </div>
          <h2>Secure Login System</h2>
          <p>
            Login is handled exclusively using the Login ID issued at registration. A Recovery Key/ID
            is generated at the time of registration — users must store this safely.
          </p>
        </div>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="shield-icon"></i>
          </div>
          <h2>Communication Policy</h2>
          <p>
          We will never initiate contact with users requesting sensitive information, as we do not want to know your personal email, or
          contact information.
          </p>
          <div className="alert-box">
            <p>
            If you receive any communication claiming to represent Omega Void™ that does not originate from either <strong>support@omegavoid.com</strong> or
              <strong> corporate@omegaopscyberdefence.com</strong>, it should be considered fraudulent.
            </p>
          </div>
        </div>

        <div className="security-principle">
          <div className="principle-icon">
            <i className="bitcoin-icon"></i>
          </div>
          <h2>Identity-Minimized Architecture</h2>
          <ul style={{ textAlign: 'left', lineHeight: '1.8', listStyleType: 'disc', paddingLeft: '20px' }}>
            <li>Control is decentralized at the identity layer.</li>
            <li>Identity is not centrally profiled.</li>
            <li>Users retain control of access keys.</li>
            <li>The platform avoids centralized identity storage.</li>
          </ul>
        </div>

        <div className="home-patent-notice" style={{ marginBottom: '30px' }}>
          <p>Technical Audit Coming Q2-Q3 2026</p>
          <div className="patent-badge">
            <span className="patent-text">PATENT PENDING</span>
          </div>
          <p className="patent-subtitle">
            Protected under U.S. Intellectual Property Law
          </p>
        </div>

        <div className="hardware-promo">
          <h3>Omega Void&trade; Whitepaper</h3>
          <p>
          This is the Omega Void™ Security Whitepaper. This is to ensure we remain transparent in everything we do on this website,
what we collect during your interactions with the site and our encryption procedures.
          </p>

          <div className="whitepaper-pdf-section" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
            <PDFPageViewer pdfUrl={pdfUrl} loadingText="Loading whitepaper document..." />
          </div>
        </div>
      </div>
      <SupportEmail />
    </>
  );
};

export default Security;
